import IndustryBenefitsI18n from "@/components/landing/shared/IndustryBenefitsI18n";
import { TrendingUp, Heart, PiggyBank, Users } from "lucide-react";
const VorteileVerbaendeSection = () => <IndustryBenefitsI18n translationPrefix="industryVerbaende" icons={[TrendingUp, Heart, PiggyBank, Users]} />;
export default VorteileVerbaendeSection;
